import { createConsumer } from '@rails/actioncable';

import grooveEngineRootUrl from 'Utils/grooveEngineRootUrl';

export default createConsumer(
  `wss://${new URL(grooveEngineRootUrl).host}/cable`
);
